module.exports = __webpack_public_path__ + "static/media/TP_Icon_Shirt.1e9ea803.png";